import fontColorContrast from 'font-color-contrast'
import React, { useEffect, useState } from 'react'
import { Alert, Col, Row, Spinner } from 'react-bootstrap'
import VerificationInput from 'react-verification-input'
import axios from 'axios'

const FormConfirmEmail = ({ data, handleResend, confirmResendData, routeToConfirm, onConfirm, onFinish }) => {

    const {
        button_color,
        text_6, // заголовок для ввода кода подтверждения 
        text_7, // заголовок для успешном вводе кода подтверждения 
        text_8, // текст прислать заново код
        text_9, // текст кнопки Отправить код
    } = data?.setting

    const text_on_success = text_7

    const [isAlertSuccess, setIsAlertSuccess] = useState(false);
    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');

    const [isLoading, setIsLoading] = useState(false); // загрузка при отправке
    const [confirmCode, setConfirmCode] = useState('')

    const TIME = 120
    const [timer, setTimer] = useState(TIME)

    let interval
    useEffect(() => {
        interval = setInterval(() => {
            setTimer(prev => prev > 0 ? --prev : 0)
        }, 1000);
        return () => {
            clearInterval(interval)
        }
    }, [])


    useEffect(() => {
        if (!timer && interval) {
            clearInterval(interval)
        }
    }, [timer, interval])

    const toFormatTimer = (time) => {
        let m = Math.trunc(time / 60);
        let s = time - (m * 60);
        return m + ':' + (s < 10 ? ('0' + s) : s)
    };

    const resendCode = () => {
        setConfirmCode('')
        setTimer(TIME)
        handleResend()
    }

    const handleConfirmCode = () => {
        setIsLoading(true)
        const sendData = { ...confirmResendData, ...{ email_code: confirmCode } }
        axios
            .post(`${process.env.REACT_APP_API_BASE}/${routeToConfirm}`, sendData)
            .then((response) => {
                if (response?.data && response.data?.res) {
                    if (response.data.res === 'Success') {
                        setIsAlertSuccess(true)
                        setIsAlertError(false)
                    }
                    if (response.data.res === 'Error') {
                        setIsAlertError(true)
                        const errText = data?.setting?.[response.data?.msgKey] || 'Что-то пошло не так, попробуйте повторить позже'
                        setTextOnError(errText)
                    }
                }

                if (response.data.token && onConfirm) {
                    onConfirm(response.data.token)
                }
                if (onFinish) {
                    onFinish()
                }
            })
            .catch((err) => {
                console.log(err)
                setIsAlertError(true)
                setTextOnError('Что-то пошло не так')
            })
            .finally(() => {
                setIsLoading(false)
            });
    }


    return (
        <div className='buildedPage-type_8-form bg-none d-flex flex-column align-items-center' style={{ gap: 16 }}>

            {
                isAlertError &&
                <Alert
                    style={{ width: '100%' }}
                    variant={'danger'}
                    onClose={() => {
                        setIsAlertError(false)
                        setTextOnError('')
                    }}
                    dismissible
                >
                    <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                    <p className='mb-0'>{textOnError}</p>
                </Alert>
            }
            {
                isAlertSuccess ?
                    <>
                        <div className='h5 mb-3 mt-3' dangerouslySetInnerHTML={{ __html: text_on_success }} />
                    </>
                    :
                    <>

                        <div className='h5 mb-3' dangerouslySetInnerHTML={{ __html: text_6 }} />
                        <VerificationInput
                            value={confirmCode}
                            onChange={(e) => {
                                setConfirmCode(e)
                            }}
                            length={4}
                            autoFocus={true}
                            placeholder={'0'}
                            classNames={{
                                character: 'character',
                                characterInactive: "character--inactive",
                                characterSelected: "character--selected",
                                characterFilled: "character--filled",
                            }}

                        />
                        <div>
                            {
                                timer ?
                                    <div className='text-muted'>{text_8} через {toFormatTimer(timer)} </div>
                                    :
                                    <div className='text-primary' onClick={resendCode} style={{ cursor: 'pointer' }}>{text_8}</div>
                            }
                        </div>
                        <button
                            disabled={confirmCode.length !== 4}
                            className='btn btn-submit'
                            type='submit'
                            style={{
                                backgroundColor: button_color,
                                color: fontColorContrast(button_color)
                            }}
                            onClick={handleConfirmCode}
                        >
                            {
                                isLoading ?
                                    <Spinner animation='border' />
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: text_9 || "Отправить" }}></div>
                            }
                        </button>

                    </>
            }
        </div>
    )
}

export default FormConfirmEmail